import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router";
import { Down } from "src/components";
import { UserSessionAction } from "src/store";
import logo from "src/assets/static/img/main/logo/anten-logo.svg";
import ios from "src/assets/static/img/main/add-to-home-screen/android-chrome.jpg";
import { _ } from "src/services";

export const IOS: React.FC = () => {

    const { push } = useHistory();
    const dispatch = useDispatch();

    const goHome = () => push("/");

    useEffect(() => {
        dispatch(UserSessionAction.pwaGuidSeen());
    }, [dispatch]);

    return (
        <div className="add-to-home-screen app-theme2 px-2 text-rtl text-right">
            <div className="d-flex flex-column h-100">
                <div className="text-center my-5">
                    <img alt="" src={logo} className="w-25" />
                </div>
                <div className="container flex-shrink-grow text-center">
                    <p>{_("pwaGuideTitle")}</p>
                    <ul>
                        <li>
                            <span dangerouslySetInnerHTML={{ __html: _("pwaIosStart").replaceAll("{icon}", "<span class='icon-mobile share'></span>") }} />
                        </li>
                        <li>
                            <span>{_("pwaSelectAddToHomeScreen")}</span>
                            <img alt="" src={ios} className="w-100 d-block icon mt-3 mx-auto" />
                        </li>
                        <li>
                            <span>{_("pwaTapOnAdd")}</span>
                        </li>
                    </ul>
                </div>
                <div className="text-center">
                    <button className="mb-3 mt-3 btn btn-md btn-primary w-50" onClick={goHome}>
                        {_("homePage")}
                    </button>
                    <div className="text-white mb-4 mt-2">
                        <span className="d-block w-100">{_("pwaIosStartTip")}</span>
                        <span className="mt-2">
                            <Down />
                        </span>
                    </div>
                </div>
            </div>
        </div >
    );

};